/** Anchor of the grant form on Workspace › MCP access. */
export const MCP_GRANT_ANCHOR = 'mcp-access-grant';
